var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#99AABB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.8889L19.9333 10L18.0667 18.8889H15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.1111L16.0667 26L17.9333 17.1111H21Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 25.15C9 25.5642 9.33579 25.9 9.75 25.9H14.25C14.6642 25.9 15 25.5642 15 25.15C15 24.7358 14.6642 24.4 14.25 24.4H9.75C9.33579 24.4 9 24.7358 9 25.15Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 20.35C9 20.7642 9.33579 21.1 9.75 21.1H13.25C13.6642 21.1 14 20.7642 14 20.35C14 19.9358 13.6642 19.6 13.25 19.6H9.75C9.33579 19.6 9 19.9358 9 20.35Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.55C9 15.9643 9.33579 16.3 9.75 16.3H12.25C12.6642 16.3 13 15.9643 13 15.55C13 15.1358 12.6642 14.8 12.25 14.8H9.75C9.33579 14.8 9 15.1358 9 15.55Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.75C9 11.1642 9.33579 11.5 9.75 11.5H15.25C15.6642 11.5 16 11.1642 16 10.75C16 10.3358 15.6642 10 15.25 10H9.75C9.33579 10 9 10.3358 9 10.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10.75C27 10.3358 26.6642 10 26.25 10H21.75C21.3358 10 21 10.3358 21 10.75C21 11.1642 21.3358 11.5 21.75 11.5H26.25C26.6642 11.5 27 11.1642 27 10.75Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15.55C27 15.1358 26.6642 14.8 26.25 14.8H22.75C22.3358 14.8 22 15.1358 22 15.55C22 15.9643 22.3358 16.3 22.75 16.3H26.25C26.6642 16.3 27 15.9643 27 15.55Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20.35C27 19.9358 26.6642 19.6 26.25 19.6H23.75C23.3358 19.6 23 19.9358 23 20.35C23 20.7642 23.3358 21.1 23.75 21.1H26.25C26.6642 21.1 27 20.7642 27 20.35Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.15C27 24.7358 26.6642 24.4 26.25 24.4H20.75C20.3358 24.4 20 24.7358 20 25.15C20 25.5642 20.3358 25.9 20.75 25.9H26.25C26.6642 25.9 27 25.5642 27 25.15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc);
export default __webpack_public_path__ + "static/media/EC.d176c2b5.svg";
export { ForwardRef as ReactComponent };